<template>
    <div class="container container-tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane :name="String(item.val)" v-for="(item, index) in mode_select" :key="index" class="to-searh">
                <span slot="label" class="table-title">{{ item.alias }}</span>
            </el-tab-pane>

            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="24" style="margin: 10px 0">
                        <span class="title">状态 : </span>
                        <el-radio-group v-model="search_data.status" size="small" @change="statusChange">
                            <el-radio label="" border>全部</el-radio>
                            <el-radio label="1" border>已开启</el-radio>
                            <el-radio label="0" border>已关闭</el-radio>
                        </el-radio-group>
                    </el-col>

                    <!-- <el-col :span="24" style="margin: 10px 0;">
            <span class="title">自创单模式 : </span>
            <el-radio-group v-model="search_data.wait_mode" size="small">
              <el-radio label="" border>全部</el-radio>
              <el-radio label="1" border>已开启</el-radio>
              <el-radio label="0" border>已关闭</el-radio>
            </el-radio-group>
          </el-col> -->
                </el-row>

                <el-button type="primary" icon="el-icon-search" @click="searchModelLists">搜索</el-button>
                <el-button @click="addBtn">添加</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            </div>
        </el-tabs>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column prop="city.name" label="城市名称" width="300"> </el-table-column>
            <el-table-column prop="order_mode_qrcode" label="二维码" min-width="120">
                <template slot-scope="scope">
                    <el-image
                        style="width: 80px; height: 80px; border: 1px solid #eee; border-radius: 5px"
                        :src="scope.row.order_mode_qrcode"
                        v-if="scope.row.order_mode_qrcode != ''"
                        :preview-src-list="srcList"
                    >
                    </el-image>
                </template>
            </el-table-column>

            <el-table-column prop="name" label="名称" width="150"> </el-table-column>

            <el-table-column prop="port.alias" label="端口"> </el-table-column>

            <!-- <el-table-column prop="partner_mode.alias" label="合作模式">

        <template slot-scope="scope">

          <el-tag :type="scope.row.partner_mode.val==='0'?'info':'warning'">
            {{scope.row.partner_mode.alias}}
          </el-tag>

        </template>

      </el-table-column> -->

            <!-- <el-table-column prop="wait_mode.alias" label="自创单模式">

        <template slot-scope="scope">

          <el-tag :type="scope.row.wait_mode.val==='0'?'info':''">
            {{scope.row.wait_mode.alias}}
          </el-tag>

        </template>

      </el-table-column> -->

            <el-table-column prop="wait_mode.alias" label="恶劣天气模式">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.is_sleet.val === '0' ? 'info' : ''">
                        {{ scope.row.is_sleet.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <!-- <el-table-column label="管理状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val === '0' ? 'info' : 'success'">
                        {{ scope.row.status.alias }}
                    </el-tag>
                </template>
            </el-table-column> -->

            <!-- <el-table-column label="模式开关">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status.val" active-value="1" inactive-value="0"
                    :disabled="search_data.openapi==1" @change="modeSwitch(scope.row)">
                    </el-switch>
                </template>
            </el-table-column> -->

            <el-table-column label="默认模式开关">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status.val" active-value="1" inactive-value="0"
                    :disabled="search_data.openapi==1" @change="modeSwitch(scope.row)">
                    </el-switch>
                </template>
            </el-table-column>

            <el-table-column label="多模式开关" v-if="activeName == '1'">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.multi_mode.val" active-value="1" inactive-value="0"
                    @change="multiModeSwitch(scope.row)">
                    </el-switch>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-dropdown
                        split-button
                        type="primary"
                        @click="editModel(scope.row.order_mode.order_mode_code, scope.row.city.name, scope.row.status.alias)"
                        trigger="click"
                    >
                        编辑模式

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="editModeCoordinate(scope.row.order_mode.order_mode_code)"
                                >订单模式围栏
                            </el-dropdown-item>

                            <el-dropdown-item @click.native="toDetil(scope.row.order_mode.order_mode_code)">模式预览 </el-dropdown-item>

                            <el-dropdown-item @click.native="delOrder(scope.row.order_mode.order_mode_code)">删除模式 </el-dropdown-item>

                            <el-dropdown-item @click.native="toBlackList(scope.row.order_mode.order_mode_code, '0')"
                                >黑名单
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="toBlackList(scope.row.order_mode.order_mode_code, '1')"
                                >白名单
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="toLabelManage(scope.row.order_mode.order_mode_code)" v-if="activeName == '1'"
                                >多模式标签管理
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div>

        <!-- 黑名单组件 -->
        <blackList :isShow="black_isShow" :data="listDate" @onSubmit="modelLists"></blackList>



        <!-- 编辑模式组件 把添加组件合并过来了 -->
        <editOrderModel
            :btnType='btnType'
            :data="drivingModel_dialog"
            :name="modeName"
            :openapi="search_data.openapi"
            :drivingModel_select="drivingModel_select"
            :isShow="editModel_isShow"
            @onSubmit="modelLists"
        ></editOrderModel>

        <cityMode :isShow="city_mode_show" :data="city_code"></cityMode>

        <!-- 订单模式围栏组件 -->
        <editModeCoordinate :isShow="editModeCoordinate_isShow" :data="editModel_dialog" @onSubmit="modelLists"></editModeCoordinate>

        <el-dialog :visible.sync="iframe_show" width="50%">
            <!-- <iframeModel :isShow="iframe_show" :param="iframe_param" :iframe_url="iframe_url" style="height: 60vh"> </iframeModel> -->
            <iframe class="" :src="iframe_url" style="height: 60vh"></iframe>
            <div style="text-align: center">
                <el-button @click="iframe_show = false" class="close-btn">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 多模式标签管理组件 -->
        <labelManage :isShow="labelManage_isShow" :data="listDate"></labelManage>
    </div>
</template>

<script>
var _this;

import blackList from './blackList.vue';

import editOrderModel from './editOrderModel.vue';
import editModeCoordinate from './editModeCoordinate.vue';
import cityMode from '../../common/cityMode.vue';
import iframeModel from '../../common/iframe.vue';
import { config } from '../../../utils/config.js'; //配置
import labelManage from './labelManage.vue';
export default {
    components: {

        blackList,
        editOrderModel,
        cityMode,
        iframeModel,
        editModeCoordinate,
        labelManage
    },
    data() {
        return {
            listDate: {},
            srcList: [],
            modeName: '',

            company_name: '',

            // 添加模式组件开关
            addModel_isShow: false,
            black_isShow: false,
            white_isShow: false,

            // 修改模式组件开关
            editModel_isShow: false,

            editModeCoordinate_isShow: false,
            editModel_dialog: '',

            // 城市模式组件开关
            city_mode_show: false,

            iframe_show: false,
            iframe_url: '',
            iframe_param: '',

            // 传入子组件的数据
            drivingModel_dialog: '',
            btnType: '', // 区分添加和编辑按钮

            // 传入子组件的数据(下拉显示内容)
            drivingModel_select: {
                city: '',
                status: ''
            },

            city_code: '',

            // 选项卡默认选中项
            activeName: '1',

            mode_price: '',

            // 下拉搜索城市
            value_city_code: '',
            options_city_code: [],
            city_options_data: {
                page: 1,
                limit: 50,
                name: ''
            },

            mode_select: [
                {
                    val: '1',
                    alias: '普通模式'
                },
                {
                    val: '2',
                    alias: '创单模式'
                },
                {
                    val: '3',
                    alias: '合作模式'
                },
                {
                    val: '4',
                    alias: '三方模式'
                },
                {
                    val: '5',
                    alias: '包时模式'
                }
            ],

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                city_code: '',
                status: '',
                openapi: '', // 三方模式
                wait_mode: '', // 自创单模式
                partner_mode: '', // 合作模式
                is_ordinary: '1', // 普通模式
                hourly_package_mode: '0' // 包时模式
            },

            result_data: {},
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            },
            labelManage_isShow: false,
        };
    },
    created() {
        _this = this;
        _this.modelLists();

        _this.value_city_code = JSON.parse(localStorage.getItem('login')).city.name;

        console.log(_this.value_city_code);

        _this.cityChange(JSON.parse(localStorage.getItem('login')).city.city_code);

        // 接收路由传参
        _this.search_data.city_code = _this.$route.query.city_code;

        if (_this.search_data.city_code != undefined) {
            _this
                .$post('/city/getCityDetails', {
                    city_code: _this.search_data.city_code
                })
                .then((res) => {
                    _this.value_city_code = res.data.name;
                    _this.company_name = res.data.company.name || '';
                })
                .catch((err) => {});
        }
        _this.iframe_url = config.h5;
    },

    methods: {
        // 状态change

        statusChange() {
            _this.search_data.page = 1;
            _this.modelLists();
        },
        // 列表模式开关 模式开启的时候走编辑页面保存按钮的验证
        modeSwitch(e) {
            console.log(e, '模式开关方法');
            // 此模式开关调用编辑页面的保存按钮方法进行判断，如果普通模式不是唯一的，则接口提示

            _this
                .$post('/order/editOrderModeSubmit', {
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
                    order_mode_code: e.order_mode.order_mode_code,
                    status: e.status.val
                })
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.modelLists();
                })
                .catch((err) => {
                    _this.modelLists();
                });
        },
        // 多模式开关
        multiModeSwitch(e) {
            console.log(e, '多模式开关方法');
            _this
                .$post('/order/editOrderModeSubmit', {
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
                    order_mode_code: e.order_mode.order_mode_code,
                    multi_mode: e.multi_mode.val
                })
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.modelLists();
                })
                .catch((err) => {
                    _this.modelLists();
                });
        },

        // 添加方法
        addBtn() {
            if (_this.activeName == '1') {
                _this.modeName = '普通';
            } else if (_this.activeName == '2') {
                _this.modeName = '创单';
            } else if (_this.activeName == '3') {
                _this.modeName = '合作';
            } else if (_this.activeName == '4') {
                _this.modeName = '三方';
            } else if (_this.activeName == '5') {
                _this.modeName = '包时';
            }
            _this.btnType = 'add';

            // _this.addModel_isShow = !_this.addModel_isShow;
            _this.editModel_isShow = !_this.editModel_isShow;



        },

        // 订单模式围栏
        editModeCoordinate(code) {
            _this.editModeCoordinate_isShow = !_this.editModeCoordinate_isShow;
            _this.editModel_dialog = code;
        },
        // 搜索
        searchModelLists() {
            _this.search_data.page = 1;
            _this.modelLists();
        },
        //模式预览
        toDetil(code) {
            _this.iframe_show = true;
            _this.iframe_param = code;
        },

        // 黑名单
        toBlackList(code, type) {
            _this.black_isShow = !_this.black_isShow;
            _this.listDate.code = code;
            _this.listDate.type = type;
        },
        // 多模式标签管理
        toLabelManage(code) {
            _this.labelManage_isShow = !_this.labelManage_isShow;
            _this.listDate.code = code;
        },
        // 选项卡选中事件
        handleClick(tab, event) {
            // 点击的选项卡所对应的val值
            console.log(tab.name,'tab.name');
            // if (tab.name != 'all') {
            //     _this.search_data.status = tab.name;
            // } else {
            //     _this.search_data.status = '';
            // }
            if (tab.name == '1') {
                _this.search_data.is_ordinary = '1';
                _this.search_data.wait_mode = '0';
                _this.search_data.partner_mode = '0';
                _this.search_data.openapi = '0';
                _this.search_data.hourly_package_mode = '0';
            } else if (tab.name == '2') {
                _this.search_data.is_ordinary = '0';
                _this.search_data.wait_mode = '1';
                _this.search_data.partner_mode = '0';
                _this.search_data.openapi = '0';
                _this.search_data.hourly_package_mode = '0';
            } else if (tab.name == '3') {
                _this.search_data.is_ordinary = '0';
                _this.search_data.wait_mode = '0';
                _this.search_data.partner_mode = '1';
                _this.search_data.openapi = '0';
                _this.search_data.hourly_package_mode = '0';
            } else if (tab.name == '4') {
                _this.search_data.is_ordinary = '0';
                _this.search_data.wait_mode = '0';
                _this.search_data.partner_mode = '0';
                _this.search_data.openapi = '1';
                _this.search_data.hourly_package_mode = '0';
            } else if (tab.name == '5') {
                _this.search_data.is_ordinary = '0';
                _this.search_data.wait_mode = '0';
                _this.search_data.partner_mode = '0';
                _this.search_data.openapi = '0';
                _this.search_data.hourly_package_mode = '1';
            }
            // _this.search_data.openapi = tab.name;

            _this.searchModelLists();
        },
        // 编辑
        editModel(code, city, status) {
            if (_this.activeName == '1') {
                _this.modeName = '普通';
            } else if (_this.activeName == '2') {
                _this.modeName = '创单';
            } else if (_this.activeName == '3') {
                _this.modeName = '合作';
            } else if (_this.activeName == '4') {
                _this.modeName = '三方';
            } else if (_this.activeName == '5') {
                _this.modeName = '包时';
            }
            _this.btnType = 'edit';
            _this.editModel_isShow = !_this.editModel_isShow;
            _this.drivingModel_dialog = code;
            _this.drivingModel_select.city = city;
            _this.drivingModel_select.status = status;
        },

        // 修改按钮
        // modify(city_code, name, synthesize) {
        //     _this.editModel_isShow = !_this.editModel_isShow;
        //     _this.drivingModel_data.drivingModel_city_code = city_code;
        //     _this.drivingModel_data.drivingModel_name = name;
        //     _this.drivingModel_data.synthesize = synthesize;
        // },

        // 获取模式
        modelLists() {
            _this
                .$post('/order/orderModeLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                    _this.srcList.length = 0;
                    for (let i = 0; i < res.data.length; i++) {
                        _this.srcList.push(res.data[i].order_mode_qrcode);
                    }
                })
                .catch((err) => {});
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;

            //初始化列表
            _this.modelLists();
        },

        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].order_mode_code);
            }
            _this.delModelSubmit_data.order_mode_code = datalist;
        },
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data.limit = val;

            //初始化列表
            _this.modelLists();
        },
        //页码变化
        handleCurrentChange(val) {
            console.log(val, 'val页码变化');
            _this.search_data.page = val;
            console.log(_this.search_data.page, '_this.search_data.page');
            _this.modelLists();
        },

        cityChange(val) {
            _this.search_data.city_code = val;
            if (val != '') {
                _this
                    .$post('/city/getCityDetails', {
                        city_code: val
                    })
                    .then((res) => {
                        _this.company_name = res.data.company.name;
                        _this.city_code = res.data.city.city_code;
                    })
                    .catch((err) => {});
            } else {
                _this.company_name = '';
            }
        },

        //搜索的下拉框弹出触发
        cityVisibleChange(val) {
            if (val && _this.options_city_code.length < 1) {
                // 请求公司管理接口获取公司唯一编码
                _this
                    .$post('/city/cityLists', _this.city_options_data)
                    .then((res) => {
                        _this.options_city_code = res.data;
                    })
                    .catch((err) => {});
            }
        },

        //删除功能
        delOrder(code) {
            _this
                .$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/order/delOrderModeSubmit', {
                            order_mode_code: code,
                            city_code: JSON.parse(localStorage.getItem('login')).city.city_code
                        })
                        .then((res) => {
                            _this.modelLists();
                            _this.$message.success('删除成功');
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.$message.info('已取消删除');
                });
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}

.content-body {
    display: flex;
    flex-wrap: wrap;
}

.content-body .el-form-item {
    width: 30%;
}
</style>
